export default "__VITE_ASSET__DAe22ohE__"